/**
 * Session Detail Route
 * Dynamic route for viewing and editing individual session details
 * Layout provided by _authenticated parent route
 * Authentication inherited from parent
 */

import { createFileRoute, useParams, useRouter } from '@tanstack/react-router';
import { SessionDetailPage } from '../../pages/Sessions/SessionDetailPage/SessionDetailPage';

/**
 * Session Detail Route Component
 * Layout (MainLayout, Sidebar, sessions panel) provided by parent _authenticated route
 */
const SessionDetailRouteComponent = () => {
  const router = useRouter();
  const { sessionId } = useParams({ from: '/_authenticated/sessions/$sessionId' });

  const handleBack = () => {
    if (window.history.length > 1) {
      router.history.back();
    } else {
      // Lazy import to avoid unused-var warning if navigate isn't needed
      window.location.href = '/sessions';
    }
  };

  return (
    <SessionDetailPage
      sessionId={sessionId}
      onBack={handleBack}
    />
  );
};

/**
 * Route Configuration
 * Path: /_authenticated/sessions/$sessionId
 * - Authentication inherited from _authenticated parent (no requireAuth needed)
 * - MainLayout structure inherited from _authenticated parent
 */
export const Route = createFileRoute('/_authenticated/sessions/$sessionId')({
  component: SessionDetailRouteComponent,
});
